import { createUseStyles } from 'react-jss'
import {
  darkGray,
  neonLime,
  black,
  neonLimeLight,
  neonLimeDark
} from '../../../styles/colors'
import { headerHeight } from '../constants'

const useStyles = createUseStyles({
  header: {
    padding: '0 20px',
    minHeight: headerHeight,
    backgroundColor: darkGray,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white'
  },

  logo: {
    width: '60px'
  },

  '@media only screen and (min-width: 1920px)': {
    header: {
      minHeight: '78px'
    },
    logo: {
      width: '88px'
    }
  },

  signInButton: {
    padding: '9px 17px 8px 17px',
    borderRadius: '4px',
    backgroundColor: neonLime,
    color: black,
    fontSize: '12px',
    lineHeight: '12px',
    textTransform: 'uppercase',
    fontFamily: 'GothamRounded',
    fontWeight: 500,
    textDecoration: 'none',
    '&:hover': {
      backgroundColor: neonLimeLight
    },
    '&:active': {
      backgroundColor: neonLimeDark
    }
  },

  grow: {
    flex: '1'
  }
})

export default useStyles
